import { EVENTS } from '../events';

export class TagsPlugin {
	/**
	 * Chat core object
	 */
	chat;

	constructor(chat){
		this.chat = chat;
	}

	init() {
		// this.chat.on(EVENTS.WSCHAT_RENDER_CHAT_CONTENT, content => this.add_tags(content));
		this.chat.on(EVENTS.WSCHAT_ON_RENDER_MESSAGE, params => this.add_tags(params.message_item, params.row));

		this.chat.$el.on('click', '.chat-bubble  .show-tags', (e) => {
			e.preventDefault();
			jQuery(e.target).parents('.chat-bubble').find('.tags-list').toggleClass('d-none');
		});

		jQuery('body').on('click', (e) => {
			if (jQuery(e.target).is('.message-item') === false && jQuery(e.target).parents('.message-item').length === 0) {
				this.chat.$el.find('.tags-list').addClass('d-none');
			}
		});
		this.chat.$el.on('click', '.chat-bubble  .tag-list-item', (e) => {
			e.preventDefault();
			const message_item = jQuery(e.target).parents('.message-item');
			const data = {
				message_id : message_item.data('message-id'),
				tag_id : jQuery(e.target).data('id'),
				action: 'wschat_admin_tag_a_message',
			};

			jQuery.post(ajaxurl, data, res => {
				this.rerender(message_item, data.tag_id);
			});
		});

		this.chat.$el.on('click', '.chat-bubble  .unlink-tag', (e) => {
			e.preventDefault();
			const message_item = jQuery(e.target).parents('.message-item');

			const data = {
				message_id : message_item.data('message-id'),
				action: 'wschat_admin_untag_a_message',
			};

			jQuery.post(ajaxurl, data, res => {
				this.rerender(message_item);
			});
		});

		this.chat.$el.on('keyup', 'input.search-tag', function () {
			const items = jQuery(this).parents('.wschat-tags-search').parent().parent().find('.list-group-item');

			if (this.value.length) {
				items.addClass('d-none');
			} else {
				items.removeClass('d-none');
			}
			items.each((i, item) =>{
				if (jQuery(item).text().toLowerCase().indexOf(this.value.toLowerCase()) > -1) {
					jQuery(item).removeClass('d-none');
				}
			});
		});
	}

	add_tags(message_item, content) {
		if (content.is_agent === true) {
			return content;
		}

		const tag_id = content.body.tag;
		const tag = this.chat.options.tags.find(t => t.id == tag_id);
		const tags = tag_id ? this.chat.options.tags.filter(t => t.id != tag_id) : this.chat.options.tags;

		const temp = tags_list_template(tags, tag);
		message_item.find('.message-item-action-badges').append(temp);
	}

	rerender(message_item, tag_id) {

		const tag = this.chat.options.tags.find(t => t.id == tag_id);
		const tags = tag_id ? this.chat.options.tags.filter(t => t.id != tag_id) : this.chat.options.tags;

		const tag_template = jQuery(tags_list_template(tags, tag));
		message_item.find('.message-item-action-badge-tag').html(tag_template.html());
	}
}

const tags_list_template = (tags, selected_tag) => `
	<div class="message-item-action-badge-tag">
		<span class="badge text-sm text-dark bg-white rounded-circle shadow-sm"><a href="#" class="${selected_tag ? '' : 'text-dark'} show-tags" ${selected_tag ? `style="color: #${selected_tag.color}"` : ''}><i class="material-icons">local_offer</i></a></span>
		<div class="bg-white shadow tags-list p-2 pb-0 d-none">
			<div class="pt-2">
				${selected_tag ? `<a href="#" data-name="${JSON.stringify(selected_tag)}" class="d-block btn btn-sm btn-link unlink-tag">Unlink</a>` : ''}
				<div class="wschat-tags-search">
					<div class="input-group input-group-sm mb-3">
  	  	  	  	  		<span class="input-group-text bg-white" id="basic-addon1"><i class="material-icons">search</i></span>
  	  	  	  	  		<input type="text" class="search-tag form-control form-control-sm" placeholder="Search tags" aria-label="Search Tags" aria-describedby="basic-addon1">
					</div>
				</div>
			</div>
			<ul class="list-group tag-list-group pb-3">
				${tags.map(tag => tag_list_item_template(tag)).join('')}
			</ul>
		</div>
	</div>
`;

const tag_list_item_template = tag => `
<a class="list-group-item d-flex align-items-center tag-list-item text-nowrap" href="#" data-id="${tag.id}">
	<span
		class="d-inline-block pr-1 rounded-circle tags-badge shadow"
		style="background-color: #${tag.color}"
	></span>
	${tag.name}
</a>
`;
